import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

// ⚠️ SÉCURITÉ (audit) : l'ancien flux OAuth « Emergent » (session_id →
// /auth/google/session) a été supprimé côté serveur car il déléguait
// l'authentification à un backend de démo tiers. La connexion Google passe
// désormais par le bouton officiel Google Identity Services sur /login.
// Cette page ne fait plus que rediriger vers la connexion.
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    window.history.replaceState(null, "", window.location.pathname);
    navigate("/login", { replace: true });
  }, [navigate]);

  return (
    <div
      data-testid="auth-callback-loader"
      className="min-h-screen flex items-center justify-center bg-[#FAFAF7]"
    >
      <Loader2 className="h-8 w-8 animate-spin text-stone-700" />
    </div>
  );
}
